var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2094 1.19043L25.0593 1H24.8168H17.001H9.18324H8.94074L8.7906 1.19043L1.60736 10.3012L1.37435 10.5967L1.59387 10.9024L16.5949 31.7916L17.001 32.3572L17.4071 31.7916L32.4061 10.9024L32.6256 10.5967L32.3926 10.3012L25.2094 1.19043Z",
    fill: "#ED6FF7",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8168 1.5H17.001H9.18324L2 10.6107L17.001 31.5L32 10.6107L24.8168 1.5Z",
    fill: "#ED6FF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 10.373H9.50049L17.001 31.4998L24.4995 10.373H17.001Z",
    fill: "#E249F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 1.5L9.50049 10.3733H24.4995L17.001 1.5Z",
    fill: "#FA6AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.6107H9.5005L17.001 1.5H9.18324L2 10.6107Z",
    fill: "#E249F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4995 10.3733H32L24.8167 1.5H17.001L24.4995 10.3733Z",
    fill: "#F989FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9367 12.0176C25.7325 12.0176 25.7325 9.22412 23.9367 9.22412C22.1409 9.22412 22.1409 12.0176 23.9367 12.0176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.5a4689776b64343c2ed44d1628057251.svg";
export { ForwardRef as ReactComponent };